import { LOCALE } from "@/config";

export const getCurrencySymbol = (options: Intl.NumberFormatOptions) => {
	if (
		!options ||
		!options.style ||
		options.style !== "currency" ||
		!options.currency
	)
		return "";

	return (
		new Intl.NumberFormat(LOCALE, {
			style: options.style,
			currency: options.currency,
		})
			.formatToParts(1)
			.find((part) => part.type === "currency")?.value || ""
	);
};
